<template>
  <div class="upload-root">
    <input  :disabled="disabled" type="file" style="display: none;" name="" ref="file" id="file" accept="image/gif,image/png,image/gif,image/jpeg">
    <div @click="click" class="box" :style="{'border':isShow?'2px dashed rgba(224,225,228,1)':''}">
        <span v-if="isShow" style="font-weight: 100;">
            +
        </span>
        <img ref="image" v-else :src="imgSrc" alt="">
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isShow:true,
      imgSrc:'',
      disabled:false
    };
  },
  mounted(){
    
  },
  methods:{
    setVal(obj,key){
      if(!!!key){
        this.isShow = obj.isShow || true;
        this.disabled = obj.disabled || false;
        this.imgSrc = obj.imgSrc || '';
      }else{
        this[key] = obj;
      }
      this.$refs.file.value = null;
    },
    click(){
      this.$refs.file.click()

      this.$refs.file.onchange = (e)=>{
        // const fileMaxSize = 50*1024;
        if(this.$refs.file.value != ""){ // 是否选中文件 
          let selectFile = this.$refs.file;
          let file = selectFile.files[0];
          let base64String = '';
          console.log('图片大小',file.size)
          // if(file.size > fileMaxSize){
          //         this.$message.warning("文件不能超过50kb")
          //         return;
          //     }
              let arr = ['.jpg','.png','.gif']
              let name = file.name.substr(file.name.lastIndexOf('.')).toLowerCase();
              if(!arr.includes(name)){
                  this.$message.warning("上传文件类型必须是图片")
                  return;
              }
              if(window.FileReader){
                  let reader = new FileReader();
                  reader.readAsDataURL(file);

                  reader.onloadend = (e) => {
                      base64String = e.target.result;
                      this.isShow = false;
                      this.imgSrc = base64String;
                      this.$emit("getBase64",base64String)
                  }
              }
        }else{
          console.log('用户取消');
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.box{
    width: 100px;
    height: 100px;
    overflow: hidden;
    border-radius: 6px;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    span{
        font-size: 50px;
        color: rgba(0,0,0,0.5);
    }
    img{
        height: 100%;
        width: 100%;
    }
}
</style>